// extracted by mini-css-extract-plugin
export default {"content":"portfolioDistribution_content__TVSQQ"};